import * as React from 'react';
import { colors } from '@styleseat/brand';

type PiggyBankIconProps = {
  width?: number;
  height?: number;
  color?: string;
  strokeColor?: string;
  coinColor?: string;
} & React.SVGProps<SVGSVGElement>;

export const PiggyBankIcon = ({
  width = 24,
  height = 24,
  color = colors.petal,
  strokeColor = colors.blackInBlack,
  coinColor = colors.sunshine,
}: PiggyBankIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0418 13.3333C23.8717 13.3333 27.3428 14.5374 29.8539 16.4976C32.2986 18.4058 33.8332 21.0352 33.8332 23.954C33.8332 26.9263 32.2417 29.5988 29.7183 31.5149L29.7179 36.6666H27.6973L26.8557 33.1864C24.8419 34.0714 22.5172 34.5748 20.0418 34.5748C17.7552 34.5748 15.5971 34.1452 13.6938 33.3821L12.9007 36.6666H10.8802L10.8795 31.886C9.45551 30.909 8.29145 29.7064 7.4858 28.3466L4.05174 26.5405L3.83325 23.6825L6.3779 22.5065C6.62579 21.1106 7.22705 19.8036 8.10473 18.6393L7.37237 15.3853L10.8826 16.0199C13.3274 14.3438 16.5337 13.3333 20.0418 13.3333Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9255 15.9908C13.3648 14.3322 16.5542 13.3333 20.042 13.3333C23.8719 13.3333 27.3429 14.5375 29.854 16.4977C32.2987 18.4059 33.8334 21.0353 33.8334 23.9541C33.8334 26.8722 32.2993 29.5012 29.8556 31.4094C29.8102 31.4448 29.7644 31.48 29.7184 31.515L29.718 36.6667H27.6974L26.8559 33.1864C26.7007 33.2546 26.5437 33.3206 26.3849 33.3842C25.5284 33.7273 24.6203 34.0028 23.6721 34.2021C22.5148 34.4453 21.2977 34.5749 20.042 34.5749C18.9622 34.5749 17.9111 34.4791 16.902 34.2976C15.9661 34.1294 15.0663 33.8874 14.2132 33.5798C14.0381 33.5166 13.865 33.4507 13.6939 33.3821L12.9009 36.6664L10.8803 36.6667L10.8796 31.8861C10.8067 31.836 10.7344 31.7854 10.6628 31.7341C9.33725 30.7854 8.25028 29.6368 7.48592 28.3466L4.05185 26.5406L3.83337 23.6825L6.37802 22.5065C6.60939 21.2037 7.14858 19.9784 7.93303 18.8741C7.98906 18.7952 8.04634 18.717 8.10485 18.6394L7.37249 15.3854L10.8828 16.02C10.897 16.0102 10.9112 16.0005 10.9255 15.9908ZM10.2117 12.5113C13.037 10.902 16.4405 10 20.042 10C24.5496 10 28.7585 11.4139 31.9051 13.8701C34.97 16.2625 37.1667 19.7907 37.1667 23.9541C37.1667 27.578 35.5036 30.7184 33.0516 33.0501L33.0511 40H25.074L24.4558 37.4433C23.0406 37.748 21.5603 37.9082 20.042 37.9082C18.6978 37.9082 17.3837 37.7827 16.1184 37.5426L15.525 40H7.54737L7.54653 33.5179C6.6472 32.7381 5.8423 31.86 5.16421 30.8918L0.86873 28.6327L0.333252 21.628L3.56125 20.1362C3.82016 19.387 4.15096 18.6707 4.54245 17.9921L3.01613 11.2106L10.2117 12.5113Z"
      fill={strokeColor}
    />
    <path
      d="M10.0833 24.1667C11.2339 24.1667 12.1667 23.2339 12.1667 22.0833C12.1667 20.9327 11.2339 20 10.0833 20C8.93274 20 8 20.9327 8 22.0833C8 23.2339 8.93274 24.1667 10.0833 24.1667Z"
      fill={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3639 17.5001C18.8858 17.5001 17.3968 17.7459 15.8907 18.2479L14.8367 15.0856C16.6641 14.4765 18.5085 14.1667 20.3639 14.1667C22.2192 14.1667 24.0637 14.4765 25.8911 15.0856L24.837 18.2479C23.331 17.7459 21.842 17.5001 20.3639 17.5001Z"
      fill={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.9985 20.4178C37.4019 20.8653 36.625 21.2086 35.7782 21.491L34.7236 18.3289C35.4303 18.0933 35.8185 17.8862 35.9985 17.7512C36.0347 17.724 36.0537 17.7069 36.0608 17.7001C36.0388 17.724 35.9144 17.875 35.9144 18.1624H39.2477C39.2477 19.2332 38.5888 19.9751 37.9985 20.4178ZM36.0641 17.6968C36.0641 17.6968 36.0631 17.6979 36.0608 17.7001C36.0628 17.6979 36.064 17.6968 36.0641 17.6968Z"
      fill={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.7072 17.9937C37.0197 17.9937 37.273 17.7404 37.273 17.4279C37.273 17.1153 37.0197 16.862 36.7072 16.862C36.3946 16.862 36.1413 17.1153 36.1413 17.4279C36.1413 17.7404 36.3946 17.9937 36.7072 17.9937ZM33.9397 17.4279C33.9397 15.8994 35.1787 14.6604 36.7072 14.6604C38.2356 14.6604 39.4746 15.8994 39.4746 17.4279C39.4746 18.9563 38.2356 20.1953 36.7072 20.1953C35.1787 20.1953 33.9397 18.9563 33.9397 17.4279Z"
      fill={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.8061 18.0433C40.188 19.6535 38.3815 20.4578 36.7713 19.8397L37.8905 16.9241L40.8061 18.0433ZM37.8905 16.9241L37.9659 16.7277C37.8574 16.6861 37.7358 16.7402 37.6942 16.8487L37.8905 16.9241Z"
      fill={strokeColor}
    />
    <path
      d="M20.0834 7.50008C21.6942 7.50008 23.0001 6.19425 23.0001 4.58341C23.0001 2.97258 21.6942 1.66675 20.0834 1.66675C18.4726 1.66675 17.1667 2.97258 17.1667 4.58341C17.1667 6.19425 18.4726 7.50008 20.0834 7.50008Z"
      fill={coinColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0833 3.33333C19.393 3.33333 18.8333 3.89298 18.8333 4.58333C18.8333 5.27369 19.393 5.83333 20.0833 5.83333C20.7737 5.83333 21.3333 5.27369 21.3333 4.58333C21.3333 3.89298 20.7737 3.33333 20.0833 3.33333ZM15.5 4.58333C15.5 2.05203 17.552 0 20.0833 0C22.6146 0 24.6667 2.05203 24.6667 4.58333C24.6667 7.11464 22.6146 9.16667 20.0833 9.16667C17.552 9.16667 15.5 7.11464 15.5 4.58333Z"
      fill={strokeColor}
    />
  </svg>
);

export default PiggyBankIcon;
